import React from 'react';
import { UncontrolledCollapse, Button, CardBody, Card, Row, Col } from 'reactstrap';

const Complete = () => (
  <div>
    <h2>Complete HD TV</h2>
    <p>90 channels in high quality, ultra sharp, High Definition! Priced starting at $115</p>
    <Button outline color="success" id="comptoggle" style={{ marginBottom: '1rem' }}>
      Show/Hide Channel Listing
    </Button>
    <UncontrolledCollapse toggler="#comptoggle">
      <Card>
        <CardBody>
        <Row>
            <Col sm="6">
              3 - WSIL ABC<br />
              4 - WSIL Weather Bug<br />
              6 - WPSD NBC<br />
              7 - WPSD This TV<br />
              8 - WPSD Antenna<br />
              9 - KAIT ABC<br />
              10 - HSN<br />
              12 - KFVS CBS<br />
              13 - KFVS CW<br />
              14 - KFVS Grit<br />
              15 - QVC<br />
              23 - KBSI FOX<br />
              24 - KBSI Comet<br />
              34 - CSPAN 1<br />
              35 - CSPAN 2<br />
              36 - CSPAN 3<br />
              37 - NASA<br />
              40 - EvineLive<br />
              49 - WDKA MyNet<br />
              50 - WDKA Charge<br />
              51 - WDKA TBD<br />
              52 - WDKA Stadium<br />
              70 - EWTN<br />
              71 - TBN<br />
              72 - TCT<br />
              73 - Daystar<br />
              74 - SMILE<br />
              75 - The Hillsong Channel<br />
              76 - JUCE tv<br />
              77 - God TV<br />
              78 - 3ABN<br />
              90 - Lake TV<br />
              481 - Event TV HD (Pay-per-view)<br />
              981 - Event TV SD (Pay-per-view)<br />
            </Col>
            <Col sm="6">
              100 - A&E<br />
              101 - AMC<br />
              102 - Bravo<br />
              103 - Comedy Central<br />
              104 - Hallmark Channel<br />
              105 - E!<br />
              107 - HGTV<br />
              108 - FXX<br />
              109 - FX<br />
              110 - Paramount Network <br />
              111 - SyFy<br />
              113 - TBS<br />
              115 - TNT<br />
              116 - USA<br />
              117 - FOOD<br />
              121 - truTV<br />
              122 - BET<br />
              124 - Grit<br />
              125 - INSP<br />
              150 - Freeform<br />
              151 - Cartoon Network<br />
              152 - Disney Channel<br />
              154 - Nickelodeon<br />
              155 - TV Land<br />
              156 - Discovery Channel<br />
              180 - CMT<br />
              183 - MTV<br />
              184 - VH1<br />
              200 - Lifetime Movies<br />
              201 - Lifetime Movie Network<br />
              202 - Oxygen<br />
              203 - OWN<br />
              250 - CNBC<br />
              251 - CNN<br />
              252 - Fox News Channel<br />
              254 - Headline News<br />
              255 - MSNBC<br />
              256 - Weather Channel<br />
              262 - History<br />
              264 - Investigation Discovery<br />
              265 - TLC<br />
              267 - Animal Planet<br />
              268 - Discovery Channel<br />
              269 - National Geographic<br />
              273 - Travel Channel<br />
              300 - ESPN<br />
              301 - ESPN2<br />
              302 - Fox Sports Midwest<br />
              303 - Fox Sports Midwest Plus<br />
              304 - Fox Sports Midwest Plus 2<br />
              305 - Fox Sports 1<br />
              313 - SEC Network<br />
              314 - SEC Network Alternate<br />
              340 - Velocity<br />
            </Col>
          </Row>
        </CardBody>
      </Card>
    </UncontrolledCollapse>
  </div>
);

export default Complete;


// WEBPACK FOOTER //
// ./src/components/sections/services/tv/complete.js